import React from "react";
import ReactECharts from "echarts-for-react";

const DebtCredt2 = () => {
  const dates = [
    "Nov-19", "Dec-19", "Jan-20", "Feb-20", "Mar-20", "Apr-20", "May-20", "Jun-20", "Jul-20", "Aug-20", "Sep-20", "Oct-20",
    "Nov-20", "Dec-20", "Jan-21", "Feb-21", "Mar-21", "Apr-21", "May-21", "Jun-21", "Jul-21", "Aug-21", "Sep-21", "Oct-21",
    "Nov-21", "Dec-21", "Jan-22", "Feb-22", "Mar-22", "Apr-22", "May-22", "Jun-22", "Jul-22", "Aug-22", "Sep-22", "Oct-22",
    "Nov-22", "Dec-22", "Jan-23", "Feb-23", "Mar-23", "Apr-23", "May-23", "Jun-23", "Jul-23", "Aug-23", "Sep-23", "Oct-23",
    "Nov-23", "Dec-23", "Jan-24", "Feb-24", "Mar-24", "Apr-24", "May-24", "Jun-24", "Jul-24", "Aug-24", "Sep-24", "Oct-24"
  ];

  const creditorsDays = [
    6.0, 1.1, 10.6, 7.6, 7.3, 13.8, 13.7, 4.9, 15.3, 6.4, 9.6, 7.2, 9.5, 9.5, 6.9, 25.7, 20.1, 18.0, 16.4, 14.0, 8.9, 12.9, 8.8, 8.1, 9.3, 2.3, 6.1, 11.6, 7.7, 8.9, 9.8, 5.6, 7.7, 7.8, 9.7, 7.3,
    5.0, 5.0, 8.4, 8.9, 9.7, 9.7, 13.1, 10.9, 18.1, 13.9, 22.3, 16.5, 13.1, 10.5, 9.6, 7.2, 13.5, 15.1, 11.1, 9.0, 9.3, 6.3, 3.8, 6.6
  ];

  const receivablesDays = [
    15.2, 14.5, 16.1, 18.7, 19.2, 20.3, 21.5, 23.0, 22.8, 24.2, 25.1, 23.9, 26.5, 27.3, 28.1, 29.0, 30.2, 31.5, 30.8, 29.7, 28.3, 27.5, 26.1, 25.3, 24.8, 24.1, 23.7, 23.2, 22.8, 21.9, 20.7, 19.8, 19.3, 18.9, 18.2, 17.6,
    17.1, 16.8, 16.4, 16.1, 15.8, 15.3, 15.0, 14.7, 14.3, 14.0, 13.7, 13.5, 13.3, 13.0, 12.8, 12.6, 12.4, 12.2, 12.0, 11.9, 11.8, 11.7, 11.6, 11.5
  ];

  // Function to calculate trend line (Linear Regression)
  const calculateTrendLine = (data) => {
    const n = data.length;
    const x = data.map((_, i) => i);
    const y = data;

    const sumX = x.reduce((acc, val) => acc + val, 0);
    const sumY = y.reduce((acc, val) => acc + val, 0);
    const sumXY = x.reduce((acc, val, i) => acc + val * y[i], 0);
    const sumX2 = x.reduce((acc, val) => acc + val * val, 0);

    const slope = (n * sumXY - sumX * sumY) / (n * sumX2 - sumX * sumX);
    const intercept = (sumY - slope * sumX) / n;

    return x.map((xi) => slope * xi + intercept);
  };

  const creditorsTrendLine = calculateTrendLine(creditorsDays);
  const receivablesTrendLine = calculateTrendLine(receivablesDays);

  const option = {
    backgroundColor: "#fff",
    title: {
      text: "Accounts Receivable & Payable Trends",
      left: "center",
      top: 10,
      textStyle: {
        color: "#333",
        fontSize: 16,
        fontWeight: "bold",
      },
    },
    tooltip: {
      trigger: "axis",
    },
    legend: {
      data: ["Account Payable Days", "Account Receivable Days", "Payable Trend Line", "Receivable Trend Line"],
      bottom: 10,
      textStyle: {
        color: "#333",
      },
    },
    xAxis: {
      type: "category",
      data: dates,
      axisLabel: {
        color: "#333",
        interval: 5,
        rotate: 45,
      },
      axisLine: {
        lineStyle: {
          color: "#333",
        },
      },
    },
    yAxis: {
      type: "value",
      axisLabel: {
        color: "#333",
      },
      splitLine: {
        show: false,
      },
    },
    series: [
      {
        name: "Account Payable Days",
        type: "line",
        data: creditorsDays,
        smooth: true,
        lineStyle: {
          color: "blue",
          width: 2,
        },
        symbol: "circle",
        symbolSize: 6,
      },
      {
        name: "Account Receivable Days",
        type: "line",
        data: receivablesDays,
        smooth: true,
        lineStyle: {
          color: "green",
          width: 2,
        },
        symbol: "circle",
        symbolSize: 6,
      },
      {
        name: "Payable Trend Line",
        type: "line",
        data: creditorsTrendLine,
        smooth: true,
        lineStyle: {
          color: "red",
          type: "dashed",
          width: 2,
        },
        symbol: "none",
      },
      {
        name: "Receivable Trend Line",
        type: "line",
        data: receivablesTrendLine,
        smooth: true,
        lineStyle: {
          color: "orange",
          type: "dashed",
          width: 2,
        },
        symbol: "none",
      },
    ],
  };

  return <ReactECharts option={option} style={{ height: "400px", width: "100%" }} />;
};

export default DebtCredt2;
